// TSS vite/03 §"Query keys convention".
// Assignments hang off the project, so invalidating one project's assignments
// does not throw away another's.

export const assignmentKeys = {
    all:      ['project-teams'],
    byProject: (projectId) => ['project-teams', 'project', String(projectId)],
    preview:  (id)         => ['project-teams', 'preview', String(id)],
};
